import React from 'react';
import { Tooltip, Icon } from 'antd';


/**
 * @component
 * @name ReCaptchaPrivacyTermsToolTip
 * @description It's the tooltip showing google's reCaptcha privacy and terms.
 */
export const ReCaptchaPrivacyTermsToolTip = () => {
  // for google privacy and terms

  return (
    <Tooltip
      placement="left"
      title={
        <div>
          This site is protected by reCAPTCHA and the Google&nbsp;
          <a href="https://policies.google.com/privacy">Privacy Policy</a>
          &nbsp;and&nbsp;
          <a href="https://policies.google.com/terms">Terms of Service</a>
          &nbsp;apply.
        </div>
      }
    >
      <Icon type="question-circle" />
    </Tooltip>
  );
};
